export default "__VITE_ASSET__jgigqt_D__"